import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBubble4"><Path d="M20.502 3.5H3.50195V22L7.50195 19.5H20.502V3.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBubble4;
